import {FC, useLayoutEffect} from "react";
import {gsap} from "gsap";
import TweenTarget = gsap.TweenTarget;
import {coin14, coin15, coin16, coin17, coin18, coin19, coin20, coin21, coin23, coin25, coin26} from "../coinsImages";
import "./CoinsLeft.scss";

const CoinsLeft: FC = () => {
	const coins = [coin19, coin14, coin17, coin16, coin26, coin14, coin25, coin23, coin15, coin21, coin18, coin20, coin15];

	useLayoutEffect(() => {
		let coinsEl: TweenTarget[] = gsap.utils.toArray(".coins-left .coin")
		coinsEl.forEach((coin, index) => {
			gsap.fromTo(coin,{ opacity: 0 },
				{
					clearProps: "all",
					opacity: 1,
					duration: 2,
					delay: 1.5 + (index / 5),
					onComplete: () => {gsap.killTweensOf(coin);}
				}
			)
		})
	}, []);

	return(
		<div className="coins-left">
			<div className="coins-left__wrapper">
				{
					coins.map((coin, index) => (
						<div className={`coin coin-${index + 1}`} key={`coin-${index + 1}`}>
							<img src={coin} alt={`coin-${index + 1}`}/>
						</div>
					))
				}
			</div>
		</div>
	)
}
export default CoinsLeft